import request from '@/utils/request'
const BASE_URL = '/StInDocProduct'


export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(id) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data: { id }
    })
  },
  GetDtoInfo(doclog) {
    return request({
      url: BASE_URL + '/GetDtoInfo',
      method: 'get',
      params: {doclog}
    })
  },
  GetPuDtoInfo(doclog) {
    return request({
      url: BASE_URL + '/GetPuDtoInfo',
      method: 'get',
      params: {doclog}
    })
  }
}